import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CATEGORY, STR_COULD_NOT_FETCH_DATA, STR_CROPS, STR_DELIVERY_LOCATION, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_OPTIONAL, STR_ORDER_NOTES, STR_ORDER_QUANTITY, STR_OVERALL_COST, STR_PACKAGING_COST, STR_PLACE_ORDER, STR_PLACE_YOUR_ORDER, STR_POST_ITEM, STR_SHIPPING_COST, STR_SUBMIT, STR_SUCCESS, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_UNIT, STR_UNIT_PRICE } from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import ImageSlider from "../ones/ImagesSlider";
import OpSuccessWidget from "../ones/OpSuccessWidget";


export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);

	const [opSuccessful, setOpSuccessful] = useState(false);

	const [data, setData] = useState(null);
	const [images, setImages] = useState([]);

	const [itemQuantity, setItemQuantity] = useState(1);
	const [deliveryLocation, setDeliveryLocation] = useState({});
	const [notes, setNotes] = useState("");
	const [totalOrderPrice, setTotalOrderPrice] = useState(0);
	const [transactionFees, setTransactionFees] = useState(0);
	const [shippingCost, setShippingCost] = useState(0);
	const [packagingCost, setPackagingCost] = useState(0);
	const [overallCost, setOverallCost] = useState(0);
	

	async function init() {
		setReady(false);
		await Promise.all([
			getData(),
		])
		setReady(true)
	}

	function getImages() {
		if(data) {
			const _images = [];

			if(data.img1) {
				_images.push(CDN_URL + data.img1);
			}

			if(data.img2) {
				_images.push(CDN_URL + data.img2);
			}

			if(data.img3) {
				_images.push(CDN_URL + data.img3);
			}

			setImages(_images);
		}
	}

	async function getData() {
		await callApi("get-item-data", { itemUuid: uuid }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	}

	function getTotalOrderPrice() {
		if(data && !isNaN(itemQuantity)) {
			let _totalOrderPrice = Number(itemQuantity) * Number(data.unitPrice);

			setTotalOrderPrice(_totalOrderPrice);
		}
	}

	function getOverallCost() {
		if(
			!isNaN(totalOrderPrice) &&
			!isNaN(shippingCost) &&
			!isNaN(packagingCost) &&
			!isNaN(transactionFees) 
		) {
			let _overallCost = Number(totalOrderPrice) + Number(shippingCost) + Number(packagingCost) + Number(transactionFees);

			setOverallCost(_overallCost);
		}
	}

	async function placeOrder() {
		if(Number(itemQuantity) > 0 && !isNaN(itemQuantity)) {
			if(
				deliveryLocation &&
				deliveryLocation.region &&
				deliveryLocation.district &&
				deliveryLocation.ward &&
				deliveryLocation.street
			) {
				setLoading(true);
				await callApi(
					'create-order',
					{
						itemUuid: uuid,
						itemQuantity,
						deliveryLocation: JSON.stringify(deliveryLocation),
						notes,
					}
				).then((response) => {
					if(response.status === 1) {
						setOpSuccessful(true);
						appContext.getMyOrders();
					} else {
						appContext.tellError(response.msg);
					}
				})
				setLoading(false);
			} else {
				appContext.tellError(STR_INVALID_LOCATION[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_QUANTITY[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getOverallCost()
	}, [ totalOrderPrice, shippingCost, packagingCost, transactionFees ])

	useEffect(() => {
		getTotalOrderPrice();
	}, [ itemQuantity ])

	useEffect(() => {
		getImages();
	}, [ data ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	if (ready && data) {
		return (
			<div className="container">
				<div className="row">
					
					<div className="col-md-12">
						<h6
							className="main-section-title"
						>
							{data.title}
						</h6>

						
					</div>

					
					<div className="col-md-6 mt-2 mb-2">
						<ImageSlider images={images} />
					</div>

					<div className="col-md-6 mt-2 mb-2">
						
						<div className="mt-3">
							{
								(data.category === 'crop') ?
								<span className="badge bg-primary">{STR_CROPS[appContext.language]}</span>
								:""
							}

							{
								(data.category === 'livestock') ?
								<span className="badge bg-secondary">{STR_LIVESTOCK[appContext.language]}</span>
								:""
							}

							<h6
								style={{
									fontSize: "28px"
								}}
								className="font-semi-bold text-secondary text-end mOneLineText"
							>
								{formatMoney(data.unitPrice)} 
								<span
									style={{
										paddingLeft: "10px",
										fontSize: "20px",
									}}
								>
									TZS
								</span>
								<span
									style={{
										paddingLeft: "10px",
										fontSize: "16px",
										display: "block",
										textTransform: "uppercase"
									}}
									className="font-bold text-muted"
								>
									{data.unit}
								</span>
							</h6>

							<label className="form-label">{STR_ITEM_DESCRIPTION[appContext.language]}</label>
							<pre
							>
								{data.description}
							</pre>	
						</div>						
						
					</div>

					{
						(opSuccessful) ?
						<div className="col-md-12 mt-2 mb-2">
							<OpSuccessWidget/>
						</div>
						:
						<div className="col-md-12 mt-2 mb-2">
							<hr/>

							<h6
								className="main-section-title"
							>
								{STR_PLACE_YOUR_ORDER[appContext.language]}
							</h6>

							<div className="row">
								<div className="col-md-6">

									<div className="mt-3 mb-3">
										<label className="form-label">{STR_ORDER_QUANTITY[appContext.language]}</label>
										<input
											className="form-control text-end font-bold"
											onChange={(e) => setItemQuantity(e.target.value)}
											style={{
												fontSize: "24px"
											}}
											value={itemQuantity}
										/>
										<div 
											className="form-text text-end"
											style={{
												fontSize: "24px",
												textTransform: "uppercase"
											}}
										>
											{data.unit}
										</div>
									</div>

									<div className="mt-2 mb-2 bg-surface p-1">
										<label className="form-label">{STR_TOTAL_ORDER_PRICE[appContext.language]}</label>
										<h6
											className="font-semi-bold text-secondary text-end"
											style={{
												fontSize: "18px"
											}}
										>
											{formatMoney(totalOrderPrice)} TZS
										</h6>
									</div>

									<div className="mt-2 mb-2 bg-surface p-1">
										<label className="form-label">{STR_TRANSACTION_FEES[appContext.language]}</label>
										<h6
											className="font-semi-bold text-secondary text-end"
											style={{
												fontSize: "18px"
											}}
										>
											{formatMoney(transactionFees)} TZS
										</h6>
									</div>

									<div className="mt-2 mb-2 bg-surface p-1">
										<label className="form-label">{STR_PACKAGING_COST[appContext.language]}</label>
										<h6
											className="font-semi-bold text-secondary text-end"
											style={{
												fontSize: "18px"
											}}
										>
											{formatMoney(packagingCost)} TZS
										</h6>
									</div>

									<div className="mt-2 mb-2 bg-surface p-1">
										<label className="form-label">{STR_SHIPPING_COST[appContext.language]}</label>
										<h6
											className="font-semi-bold text-secondary text-end"
											style={{
												fontSize: "18px"
											}}
										>
											{formatMoney(shippingCost)} TZS
										</h6>
									</div>

									<div className="mt-2 mb-2 bg-surface p-1">
										<label className="form-label">{STR_OVERALL_COST[appContext.language]}</label>
										<h6
											className="font-semi-bold text-secondary text-end"
											style={{
												fontSize: "24px"
											}}
										>
											{formatMoney(overallCost)} TZS
										</h6>
									</div>

								</div>

								<div className="col-md-6">
									<div className="mt-3 mb-3">
										<label className="form-label">{STR_DELIVERY_LOCATION[appContext.language]}</label>
										<NapaAddressPicker
											callback={setDeliveryLocation}
										/>
									</div>

									<div className="mt-3 mb-3">
										<label className="form-label">{STR_ORDER_NOTES[appContext.language]}</label>
										<textarea
											className="form-control"
											value={notes}
											onChange={(e) => setNotes(e.target.value)}
										/>
										<div className="form-text">{STR_OPTIONAL[appContext.language]}</div>
									</div>
								</div>

								<div className="col-md-12 mt-3 mb-5">
									<button
										className="btn btn-block btn-padded btn-primary btn-rounded"
										style={{
											textTransform: "uppercase"
										}}
										onClick={placeOrder}
									>
										{STR_SUBMIT[appContext.language]}
									</button>
								</div>
							</div>
						</div>
					}

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
	
}